<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      color: 'gold',
      headers: [
        { text: 'Booking ID', value: 'id', sortable: false },
        { text: 'Booked on', value: 'booked', sortable: false },
        { text: 'Stay period', value: 'stayPeriod', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
      ],
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<template>
  <VDialog v-model="dialog" max-width="720px" persistent>
    <VCard>
      <VCardText>
        <VLayout row wrap>
          <div class="title mb-2" :class="`${color}--text`">Member Detail</div>
          <VFlex class="mb-4" xs12>
            <BaseDisplayText label="ID" :text="item.id" />
            <BaseDisplayText label="First name" :text="item.firstName" />
            <BaseDisplayText label="Last name" :text="item.lastName" />
            <BaseDisplayText label="Email" :text="item.email" />
            <BaseDisplayText label="Country" :text="item.country" />
            <BaseDisplayText label="Point" :text="item.point" />
          </VFlex>
          <VFlex class="mb-4" xs12>
            <div class="title mb-2" :class="`${color}--text`"
              >Booking History</div
            >
            <VDataTable
              :headers="headers"
              :items="item.reservations"
              hide-actions
            >
              <template v-slot:items="props">
                <td>{{ props.item.id }}</td>
              </template>
            </VDataTable>
          </VFlex>
        </VLayout>
      </VCardText>

      <VCardActions>
        <VSpacer />
        <VBtn depressed @click="dialog = false">
          Close
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
